module.exports = __webpack_public_path__ + "8711c2ab5866b174e089c2743c797ffc.jpg";